export enum MenonColor {
  Bibelirot = 'bibelirot',
  Waldbeeri = 'waldbeeri',
  Pinkpanter = 'pinkpanter',
  Auraheilerin = 'auraheilerin',
  Einhornzunge = 'einhornzunge',
  Suffblaue = 'suffblaue',
  Bergseeli = 'bergseeli',
  Brienzersee = 'brienzersee',
  Gorgonzola = 'gorgonzola',
  Marsmenschli = 'marsmenschli',
  Grasfroschli = 'grasfroschli',
  Kunstrasen = 'kunstrasen',
  Seich = 'seich',
  Dromedar = 'dromedar',
  Hardopfuschinti = 'hardopfuschinti',
  Feuerbusch = 'feuerbusch',
}

export const menonColors = [
  MenonColor.Bibelirot,
  MenonColor.Waldbeeri,
  MenonColor.Pinkpanter,
  MenonColor.Auraheilerin,
  MenonColor.Einhornzunge,
  MenonColor.Suffblaue,
  MenonColor.Bergseeli,
  MenonColor.Brienzersee,
  MenonColor.Gorgonzola,
  MenonColor.Marsmenschli,
  MenonColor.Grasfroschli,
  MenonColor.Kunstrasen,
  MenonColor.Seich,
  MenonColor.Dromedar,
  MenonColor.Hardopfuschinti,
  MenonColor.Feuerbusch,
]

export const compareMenonColors = (a: MenonColor, b: MenonColor): number => {
  const indexA = menonColors.indexOf(a)
  const indexB = menonColors.indexOf(b)

  if (indexA > indexB) {
    return 1
  }
  if (indexA < indexB) {
    return -1
  }
  return 0
}
